const STRIPE_PUBLISHABLE = process.env.NODE_ENV === 'production'
	? 'pk_live_F5dyrZbjSBugg5RXw7musGWm'
	: 'pk_test_umIDmVXhWC2TcG2MEgsgga0x';

export default STRIPE_PUBLISHABLE;
